import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatUrl',
  pure: true,
})
export class FormatUrlPipe implements PipeTransform {
  public transform(url: string): string {
    return url.includes('imgix.net') ? url + '?q=75' : url;
  }
}
